module.exports = __webpack_public_path__ + "media/application/images/ui/homepage-background-4e7bc7d30576f8a37c85d5922ffa06af.jpg";